export class P2P {
    constructor(roomName, teamName, teamId = undefined, userId = undefined) {
        // eslint-disable-next-line no-undef
        this.drone = new Scaledrone('hkdotqtBFdyhLf4n', {
            data: { teamName, teamId, userId}
        });
        this.roomName = 'observable-' + roomName;
        this.room = null;
        this.members = [];
        this.connectionEstablished = false;
        console.log('[P2P] Instantiated')
    }

    openConnection(callback = null) {
        this.drone.on('open', error => {
            if (error) return console.error('[P2P] Drone open error : ', error)
            console.log('[P2P] Drone open')
            this.room = this.drone.subscribe(this.roomName);
            this.room.on('open', error => {
                if (error) return console.log('[P2P] Room open error : ', error)
                console.log('[P2P] Room open')
                this.connectionEstablished = true;
                if (callback) callback()
            })
            this.registerMembersEvent()
        })
        this.drone.on('error', error => {
            console.error('[P2P] Drone error : ',  error);
        });
        this.drone.on('close', event => {
            console.log('[P2P] Drone close : ', event);
        });
    }

    registerEvents(role, listEventCallback) {
        var counter = 0;
        var timer = setInterval(() => {
            if (this.connectionEstablished) {
                console.log('[P2P] Register events : ', listEventCallback)
                this.room.on('data', (message, client) => {
                    if (client.id === this.drone.clientId) return;
                    if (message.to !== role) return;
                    if (message.client_id && message.client_id !== this.drone.clientId) return
                    console.log('[P2P] Received message : ', message, client)
                    listEventCallback.forEach((item) => {
                        if (item.eventName === message.eventName) item.callback(message, client)
                    })
                });
                clearInterval(timer)
            } else if (counter > 4) {
                console.log('[P2P] Can\'t register events : ', listEventCallback);
                clearInterval(timer)
            }
            counter++;
        }, 500)
    }

    sendMessage(message) {
        var counter = 0;
        var timer = setInterval(() => {
            if (this.connectionEstablished) {
                console.log('[P2P] Send Message : ', message)
                this.drone.publish({room: this.roomName, message});
                clearInterval(timer)
            } else if (counter > 4) {
                console.log('[P2P] Can\'t publish message : ', message);
                clearInterval(timer)
            }
            counter++;
        }, 500)
    }

    registerMembersEvent() {
        this.room.on('members', m => {
            this.members = m;
        });
            
        this.room.on('member_join', member => {
            this.members.push(member);
        });
            
        this.room.on('member_leave', ({id}) => {
            const index = this.members.findIndex(member => member.id === id);
            this.members.splice(index, 1);
        });
    }
};
